import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Card, Col, Container, Modal, Row, Form } from "react-bootstrap"
import { getInvolvedTypes, importInvolvedTypesFromEbroker } from "../../actions/other/sinestersActions"
import { RootState, AppDispatch } from "../../store"
import { CustomDataTable } from "../../components/design/Datatables/CustomDataTable"
import { useAuth } from "../../components/auth/useAuth"
import { useTranslation } from "react-i18next"
import Swal from "sweetalert2"

export interface InvolvedType {
    _id?: string
    name?: string
    ebrokerId?: number
}

export default function InvolvedTypeManagement() {
    const { t } = useTranslation()
    const { clientauth } = useAuth()
    const dispatch: AppDispatch = useDispatch()

    const [page, setPage] = useState<number>(1)
    const [limit, setLimit] = useState<number>(25)
    const [search, setSearch] = useState<string>("")
    const [totalRows, setTotalRows] = useState<number>(0)

    const { involvedTypes, loadingtypes } = useSelector((state: RootState) => state.sinesters)

    useEffect(() => {
        if (clientauth) {
            dispatch(getInvolvedTypes() as any)
        }
    }, [dispatch, t, clientauth])

    const handleImportInvolvedTypes = () => {
        Swal.fire({
            icon: 'question',
            title: t('sinesterTranslate.importInvolvedTypesFromEbroker')!,
            text: t('sinesterTranslate.importInvolvedTypesAreYouSure')!,
            showDenyButton: true,
            confirmButtonText: t('global.ok')!,
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(importInvolvedTypesFromEbroker())
            }
        })
    }

    const columnsCompanias = [
        {
            name: t("sinesterTranslate.ebrokerId"),
            selector: (involved: InvolvedType) => involved.ebrokerId?.toString() || "-",
            sortable: true,
            maxWidth: "160px",
            center: true,
        },
        {
            name: t("sinesterTranslate.name"),
            selector: (involved: InvolvedType) => involved.name || "",
            sortable: true,
            wrap: true,
        }
    ]


    return (
        <Container className='p-1 py-5 p-md-5'>
            <Row>
                <Col xs={12}>
                    <h1>{t('menus.involvedType')}</h1>
                </Col>
                <Col xs={12} className='d-flex justify-content-end'>
                    <button className="btn btn-primary" onClick={handleImportInvolvedTypes}>
                        {t("sinesterTranslate.importInvolvedTypesFromEbroker")}
                    </button>
                </Col>
            </Row>
            <Row>
                <Col xs={12} className='my-3'>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    {loadingtypes ? (
                                        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                            <div className="spinner-border" role="status"></div>
                                            <span className="sr-only">{t("global.loading")}</span>
                                        </div>
                                    ) : involvedTypes?.length > 0 ? (
                                        <CustomDataTable
                                            columns={columnsCompanias}
                                            data={involvedTypes}
                                            search={search}
                                            setSearch={setSearch}
                                            page={page}
                                            setPage={setPage}
                                            limit={limit}
                                        />
                                    ) : (
                                        <h4 className="mt-4">{t("sinesterTranslate.thereisnotsinesterstypes")}</h4>
                                    )}
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    )
}